export const dictionary = {
  ADD: {
    ES: "Añadir",
    EN: "Add",
  },
  ADDED_TO_CART: {
    ES: "¡Producto añadido al carrito!",
    EN: "Product added to cart!",
  },
  SEE_ORDER: {
    ES: "Ver pedido",
    EN: "Go to cart",
  },
  CREATED_WITH: {
    ES: "Creado con ",
    EN: "Created with ",
  },
  SOCIAL_MEDIA: {
    ES: "Nuestras redes sociales",
    EN: "Our social media",
  },
  EMPTY_STORE: {
    ES: "Agrega tus categorías y productos para comenzar a utilizar tu tienda.",
    EN: "Start by adding categories and products.",
  },
  PROMOTION: {
    ES: "Promoción",
    EN: "Promotion",
  },
  FEATURED: {
    ES: "Productos destacados",
    EN: "Featured products",
  },
  NOT_AVAILABLE: {
    ES: "No disponible",
    EN: "Not available"
  }
} as const;
